import { render, staticRenderFns } from "./VitalsRepresentation.vue?vue&type=template&id=0a67ad9c&"
import script from "./VitalsRepresentation.vue?vue&type=script&lang=js&"
export * from "./VitalsRepresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports